import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ForumColorProvider } from "@/context/ForumColorContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/CalendarPage";
import Matters from "@/pages/Matters";
import MatterDiary from "@/pages/MatterDiary";
import Courts from "@/pages/Courts";
import Settings from "@/pages/Settings";
import Overview from "@/pages/Overview";
import CauseList from "@/pages/CauseList";
import AssociateBrief from "@/pages/AssociateBrief";
import Todos from "@/pages/Todos";
import PostIts from "@/pages/PostIts";
import Uncategorized from "@/pages/Uncategorized";
import DueBoard from "@/pages/DueBoard";
import Alerts from "@/pages/Alerts";
import PrintSheet from "@/pages/PrintSheet";
import BoardSnapshot from "@/pages/BoardSnapshot";
import DayKit from "@/pages/DayKit";
import ApiDocs from "@/pages/ApiDocs";
import ConnectClaude from "@/pages/ConnectClaude";
import ClerkSheet from "@/pages/ClerkSheet";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/clerk/:token" element={<ClerkSheet />} />
      <Route
        path="/connect"
        element={
          <ProtectedRoute>
            <ConnectClaude />
          </ProtectedRoute>
        }
      />
      <Route
        path="/print"
        element={
          <ProtectedRoute>
            <PrintSheet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/postits/print"
        element={
          <ProtectedRoute>
            <BoardSnapshot />
          </ProtectedRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clerk" element={<ClerkSheet />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/causelist" element={<CauseList />} />
        <Route path="/brief" element={<AssociateBrief />} />
        <Route path="/todos" element={<Todos />} />
        <Route path="/postits" element={<PostIts />} />
        <Route path="/kit" element={<DayKit />} />
        <Route path="/uncategorized" element={<Uncategorized />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/due" element={<DueBoard />} />
        <Route path="/matters" element={<Matters />} />
        <Route path="/matters/:matterId" element={<MatterDiary />} />
        <Route path="/courts" element={<Courts />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/docs" element={<ApiDocs />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ForumColorProvider>
            <Toaster position="top-right" richColors />
            <AppRouter />
          </ForumColorProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
